module.exports = __webpack_public_path__ + "img/huangguan@2x.bc7dc771.png";